import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { workerActions } from "../../../store/slices/workers";

export const deleteSharedLinksId = "deleteSharedLinks";

const UIText = {
  "es-CL": {
    success: "Los enlaces fueron eliminados exitosamente",
    error: "Error al eliminar el enlace de descarga:",
  },
  "en-US": {
    success: "The download links were deleted successfully",
    error: "Error while trying to delete the download link:",
  },
};

// deleting shared links
const deleteSharedLinks = ({ server, cloner_key, links, locale }) => {
  const { success, error } = UIText[locale];

  return async (dispatch) => {
    dispatch(workerActions.start(deleteSharedLinksId));

    try {
      for (const link of links) {
        const url = server + "api/share";
        await axios.delete(url, {
          params: { id: link.id },
          headers: { cloner_key },
        });
      }

      dispatch(workerActions.finish({ id: deleteSharedLinksId }));
      enqueueSnackbar(success, { variant: "success" });
    } catch (e) {
      console.error(e);
      dispatch(workerActions.finish({ id: deleteSharedLinksId, errors: e.message }));
      enqueueSnackbar(error + e.message, { variant: "error" });
    }
  };
};

export default deleteSharedLinks;
